<template>
  <router-view></router-view>
</template>

<script>
export default {
  data () {
    return { }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue